<mat-card class="form-card">
  <mat-card-header class="form-card-header">
    <mat-form-field class="form-field-m">
      <mat-label>{{ 'APPLICATIONS.VERSION' | translate }}</mat-label>
      <mat-select [(ngModel)]="displayedVersion" (valueChange)="changeVersion()">
        <mat-option *ngFor="let conf of form.controls.configurations?.value" [value]="conf.version">
          {{ conf.version }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button
      class="space-h-s btn-submit"
      mat-raised-button
      [disabled]=""
      (click)="addVersion()"
      *ngIf="form.controls.configurations?.value?.length"
    >
      <span class="fa fa-plus"></span>
    </button>
    <button class="space-h-s btn-submit" mat-raised-button (click)="editVersionName()" *ngIf="form.controls.configurations?.value?.length">
      {{ 'APPLICATIONS.BTNS.CHANGE_VERSION_NAME' | translate }}
    </button>
    <button class="space-h-s btn-submit" mat-raised-button (click)="importVersion()" *ngIf="form.controls.configurations?.value?.length">
      {{ 'APPLICATIONS.BTNS.IMPORT' | translate }}
    </button>
    <button
      class="space-h-s btn-submit"
      mat-raised-button
      [disabled]="form.controls.currentVersion.value === displayedVersion"
      (click)="setVersionDefault()"
      *ngIf="form.controls.configurations?.value?.length"
    >
      {{
        (form.controls.currentVersion.value === displayedVersion ? 'APPLICATIONS.DEFAULT_VERSION' : 'APPLICATIONS.SET_DEFAULT_VERSION')
          | translate
      }}
    </button>
    <div
      *ngIf="form.controls.configurations?.value?.length"
      style="margin-left: auto"
      matTooltip="{{
        (form.controls.currentVersion.value === displayedVersion
          ? 'APPLICATIONS.BTNS.CANTDELETEVERSION'
          : 'APPLICATIONS.BTNS.DELETEVERSION'
        ) | translate
      }}"
    >
      <button
        class="space-h-s btn-cancel"
        style="right: 15px; position: absolute"
        mat-raised-button
        [disabled]="form.controls.currentVersion.value === displayedVersion"
        (click)="deleteVersion()"
      >
        <span class="fa fa-trash"></span>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content class="form-card-content">
    <!--    NO VERSIONS-->
    <div class="alert alert-info" *ngIf="!findCurrentVersionConfiguration()">
      <p>
        {{ 'APPLICATIONS.NO_VERSION_MSG' | translate }}
        <button class="space-h-s btn-next" mat-raised-button [disabled]="" (click)="addVersion()">
          {{ 'APPLICATIONS.BTNS.CREATE_VERSION' | translate }}
        </button>
      </p>
    </div>

    <ng-container *ngIf="findCurrentVersionConfiguration(); let currentVersionConfiguration">
      <div class="zone-top">
        <!--            GENERAL-->
        <mat-card class="form-card zone-general">
          <mat-card-header class="form-card-header">
            <mat-card-title class="form-card-header-txt">{{ 'APPLICATIONS.GENERAL' | translate }} </mat-card-title>
          </mat-card-header>
          <mat-card-content class="form-card-content">
            <app-form-field-select-autocomplete
              class="form-field-maxi"
              [label]="'APPLICATIONS.DOMAINS'"
              [(model)]="currentVersionConfiguration.availableDomains"
              [useModel]="true"
              [useKeyAndName]="true"
              (valueOnChange)="domainChange($event); checkEmptyErrors()"
              [completeList]="domainsList"
            ></app-form-field-select-autocomplete>
            <app-form-field-select-autocomplete
              class="form-field-maxi"
              [label]="'APPLICATIONS.MARKETS'"
              [(model)]="currentVersionConfiguration.availableMarkets"
              [useModel]="true"
              [defaultValue]="currentVersionConfiguration.defaultMarket"
              [useKeyAndName]="true"
              (valueOnChange)="marketChange(currentVersionConfiguration, $event); checkEmptyErrors()"
              [completeList]="marketsList"
            ></app-form-field-select-autocomplete>
            <mat-form-field class="form-field-m">
              <mat-label>{{ 'APPLICATIONS.DEFAULT_MARKET' | translate }}</mat-label>
              <mat-select [(ngModel)]="currentVersionConfiguration.defaultMarket">
                <mat-option *ngFor="let market of currentVersionConfiguration.availableMarkets" [value]="market">
                  {{ getMarketLabel(market) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span>{{ 'APPLICATIONS.SPECIFIC_FIELDS.TITLE' | translate }} <mat-chip>JSON</mat-chip></span>
            <app-form-field-json-object [model]="currentVersionConfiguration" [restrictedList]="allRestrictedFields">
            </app-form-field-json-object>
          </mat-card-content>
        </mat-card>

        <!--            DANGER ZONE UPDATE-->
        <mat-card class="form-card zone-update" *ngIf="form.controls.nature.value === APP_KEY">
          <mat-card-header class="form-card-header">
            <mat-card-title class="form-card-header-txt">{{ 'APPLICATIONS.DANGER_ZONE' | translate }} </mat-card-title>
          </mat-card-header>
          <mat-card-content class="form-card-content">
            <p class="alert alert-info">{{ 'APPLICATIONS.DANGER_ZONE_MSG' | translate }}</p>
            <p>
              <mat-checkbox class="checkbox" [(ngModel)]="currentVersionConfiguration.shouldUpgrade">
                {{ 'APPLICATIONS.SHOULD_UPGRADE' | translate }}
              </mat-checkbox>
            </p>
            <p>
              <mat-checkbox class="checkbox" [(ngModel)]="currentVersionConfiguration.mustUpgrade">
                {{ 'APPLICATIONS.MUST_UPGRADE' | translate }}
              </mat-checkbox>
            </p>
          </mat-card-content>
        </mat-card>
      </div>

      <!--            MARKET LIST-->
      <mat-card class="form-card" *ngIf="currentVersionConfiguration && currentVersionConfiguration.markets">
        <mat-card-header class="form-card-header">
          {{ 'APPLICATIONS.MARKETS' | translate }}
        </mat-card-header>
        <mat-card-content class="form-card-content">
          <mat-tab-group dynamicHeight class="client-tabs">
            <ng-container *ngFor="let marketConfiguration of currentVersionConfiguration.markets; let index = index">
              <mat-tab [label]="marketConfiguration.name">
                <app-button-copy-field
                  style="float: right"
                  [marketList]="currentVersionConfiguration.markets"
                  (clicked)="copyToMarket($event, 'ALL', marketConfiguration)"
                ></app-button-copy-field>

                <div class="column">
                  <div>
                    <span>{{ 'APPLICATIONS.EXCEPTIONS.TITLE' | translate }} <mat-chip>JSON</mat-chip></span
                    ><br />
                    <ng-container *ngIf="marketConfiguration.exceptions && marketConfiguration.exceptions.length">
                      <mat-nav-list>
                        <mat-list-item [disabled]="true" class="exception-header">
                          <div class="exception-object-item">
                            <p>{{ 'APPLICATIONS.EXCEPTIONS.COUNTRY' | translate }}</p>
                            <p>{{ 'APPLICATIONS.EXCEPTIONS.LANG' | translate }}</p>
                            <p>{{ 'APPLICATIONS.EXCEPTIONS.LANG_RCU' | translate }}</p>
                          </div>
                        </mat-list-item>
                        <mat-list-item
                          mat-list-item
                          *ngFor="let exception of marketConfiguration.exceptions; let indexExeption = index"
                          class="list-item"
                        >
                          <div class="exception-object-item">
                            <div>
                              <mat-form-field>
                                <mat-select [(value)]="exception.country">
                                  <mat-option *ngFor="let country of countriesList" [value]="country.key">
                                    {{ country.translatedName }} ({{ country.key }})
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>

                            <div>
                              <mat-form-field>
                                <mat-select [(value)]="exception.lang">
                                  <mat-option [value]="''">{{ 'APPLICATIONS.EXCEPTIONS.FALLBACK' | translate }}</mat-option>
                                  <mat-option *ngFor="let lang of marketConfiguration.availableLangs" [value]="lang">
                                    {{ lang }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>

                            <div>
                              <mat-form-field>
                                <input matInput [(ngModel)]="exception.rcuLang" />
                              </mat-form-field>
                            </div>

                            <button class="cursor" role="button" (click)="removeException(marketConfiguration, indexExeption)">
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                        </mat-list-item>
                      </mat-nav-list>
                    </ng-container>
                    <button
                      class="space-h-s btn-submit"
                      style="margin-left: 0"
                      mat-raised-button
                      (click)="addException(marketConfiguration)"
                    >
                      {{ 'APPLICATIONS.EXCEPTIONS.ADD' | translate }} <i class="fa fa-plus"></i>
                    </button>
                    <br />
                    <br />
                    <br />
                  </div>

                  <div class="perimeter">
                    <mat-form-field class="form-field-m">
                      <mat-label>{{ 'APPLICATIONS.PROFILE_PERIMETER' | translate }}</mat-label>
                      <mat-select
                        [(ngModel)]="marketConfiguration.profilePerimeter"
                        (ngModelChange)="updateProfile(marketConfiguration); checkEmptyErrors()"
                        required
                      >
                        <mat-option *ngFor="let profil of profilePerimetersList" [value]="profil.key">
                          {{ profil.translatedName }} ({{ profil.key }})
                        </mat-option>
                      </mat-select>
                      <app-button-copy-field
                        matSuffix
                        style="display: inline-flex"
                        [marketList]="currentVersionConfiguration.markets"
                        (clicked)="copyToMarket($event, 'profilePerimeter', marketConfiguration)"
                      ></app-button-copy-field>
                    </mat-form-field>

                    <mat-form-field class="form-field-m" appearance="fill" *ngIf="marketConfiguration.profilePerimeter">
                      <mat-label>{{ 'APPLICATIONS.RCU.BASE_URL' | translate }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="marketConfiguration.rcuBaseUrl"
                        name="rcuBaseUrl"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="true"
                      />
                    </mat-form-field>
                    <mat-form-field class="form-field-m" appearance="fill" *ngIf="marketConfiguration.profilePerimeter">
                      <mat-label>{{ 'APPLICATIONS.RCU.MARKET' | translate }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="marketConfiguration.rcuMarket"
                        name="rcuMarket"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="true"
                      />
                    </mat-form-field>
                    <mat-form-field class="form-field-m" appearance="fill" *ngIf="marketConfiguration.profilePerimeter">
                      <mat-label>{{ 'APPLICATIONS.RCU.BRAND' | translate }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="marketConfiguration.rcuBrand"
                        name="rcuBrand"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="true"
                      />
                    </mat-form-field>
                  </div>

                  <app-form-field-select-autocomplete
                    class="form-field-maxi"
                    [label]="'APPLICATIONS.AVAILABLE_LANGS'"
                    [(model)]="form.controls.configurations.value[findCurrentIndexVersion()].markets[index].availableLangs"
                    [useModel]="true"
                    [defaultValue]="marketConfiguration.defaultLang"
                    [useKeyAndName]="true"
                    [completeList]="marketLang[marketConfiguration.name]"
                  ></app-form-field-select-autocomplete>

                  <mat-form-field class="form-field-m">
                    <mat-label>{{ 'APPLICATIONS.DEFAULT_LANG' | translate }} (JSON)</mat-label>
                    <mat-select
                      [(ngModel)]="form.controls.configurations.value[findCurrentIndexVersion()].markets[index].defaultLang"
                      (ngModelChange)="checkEmptyErrors()"
                      required
                    >
                      <mat-option *ngFor="let lang of marketConfiguration.availableLangs" [value]="lang">
                        {{ lang }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="form-field-m">
                    <mat-label>{{ 'APPLICATIONS.DEFAULT_COUNTRY' | translate }} (JSON)</mat-label>
                    <mat-select
                      [(ngModel)]="form.controls.configurations.value[findCurrentIndexVersion()].markets[index].defaultCountry"
                      (ngModelChange)="checkEmptyErrors()"
                      required
                    >
                      <mat-option *ngFor="let country of countriesList" [value]="country.key">
                        {{ country.translatedName }} ({{ country.key }})
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-checkbox
                    class="checkbox"
                    *ngIf="form.controls.nature.value === APP_KEY"
                    [(ngModel)]="marketConfiguration.isAccountMandatory"
                    >{{ 'APPLICATIONS.MANDATORY_ACCOUNT' | translate }}</mat-checkbox
                  >

                  <!-- Handle domain's activation status and some other properties linked to the domain -->
                  <div
                    *ngIf="
                      canManageActivatedDomainsByMarket(form.controls.nature?.value) &&
                      marketConfiguration.domainsWithApplianceCapacity !== undefined &&
                      marketConfiguration.domainsWithApplianceCapacity !== null
                    "
                    class="column"
                  >
                    <span
                      >{{ 'APPLICATIONS.DEFAULT_APPLIANCE' | translate }} <mat-chip>JSON</mat-chip>
                      <app-button-copy-field
                        style="display: inline-flex; margin: 0 5px"
                        [marketList]="currentVersionConfiguration.markets"
                        (clicked)="copyToMarket($event, 'domainsWithApplianceCapacity', marketConfiguration)"
                      ></app-button-copy-field>
                    </span>
                    <app-domains-activation-form
                      [appliancesListByDomainMarket]="allAppliances"
                      [domainsByKey]="domainsObject"
                      [currentMarketKey]="marketConfiguration.name"
                      [domainsWithApplianceCapacityList]="marketConfiguration.domainsWithApplianceCapacity"
                      [unitsList]="unitsList"
                      (modelChanged)="checkEmptyErrors()"
                    >
                    </app-domains-activation-form>
                  </div>
                  <!--Service management-->
                  <app-service-management
                    *ngIf="form.controls.configurations.value[findCurrentIndexVersion()].markets[index]?.isServiceManagementEnabled"
                    (serviceFormValues)="updateDigitalServiceForm($event)"
                    (formStatusChanged)="onServicesFormStatusChange($event)"
                    [servicesConfs]="form.controls.configurations.value[findCurrentIndexVersion()].markets[index]?.servicesConfs"
                    [marketName]="form.controls.configurations.value[findCurrentIndexVersion()].markets[index]?.name"
                    ><app-button-copy-field
                      copyButtonToMarket
                      style="display: inline-flex; margin: 0 5px"
                      [marketList]="form.controls.configurations.value[findCurrentIndexVersion()].markets"
                      (clicked)="copyToMarket($event, 'SERVICE_MANAGEMENT', marketConfiguration)"
                    ></app-button-copy-field
                  ></app-service-management>
                  <!-- Market specific fields configuration -->
                  <div class="configuration-part">
                    <span
                      >{{ 'APPLICATIONS.SPECIFIC_FIELDS.TITLE' | translate }} <mat-chip>JSON</mat-chip>
                      <app-button-copy-field
                        style="display: inline-flex; margin: 0 5px"
                        [marketList]="form.controls.configurations.value[findCurrentIndexVersion()].markets"
                        (clicked)="copyToMarket($event, 'SPECIFIC_FIELDS', marketConfiguration)"
                      ></app-button-copy-field>
                    </span>
                    <app-form-field-json-object
                      [model]="form.controls.configurations.value[findCurrentIndexVersion()].markets[index]"
                      (fieldChange)="changeJSONVersion($event)"
                      [restrictedList]="allRestrictedFields"
                    >
                    </app-form-field-json-object>
                  </div>
                </div>
              </mat-tab>
            </ng-container>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </mat-card-content>
</mat-card>
